<template>
  <!-- eslint-disable -->
  <div>
    <b-overlay variant="white" :show="showLoading" spinner-variant="primary" blur="0" opacity=".75" rounded="sm">
      <caja-filters ref="filters" />
      <b-card no-body class="mb-0">
        <b-table
          class="position-relative"
          :hover="true"
          :items="records"
          responsive
          :fields="fields"
          show-empty
          empty-text="No existen"
          @sort-changed="sortChanged"
        >

        <template #cell(quote.updated_at)="data">
          <span>{{ formatDateTime(data.item.quote.updated_at) }}</span>
        </template>

        <template #cell(actions)="data">
            <b-button size="sm" @click="detail(data.item)" v-b-tooltip.hover.top="'Detalle'" variant="flat-info">
              <feather-icon icon="BoxIcon" />
            </b-button>
            
        </template>
        </b-table>

        <div class="mx-2 mb-2">
          <b-row>
            <b-col sm="3">
              <b-form-group label-cols="4" label-cols-md="4" label-size="md" label="Entradas" label-for="input-md">
                <b-form-select
                  v-model="showEntrie"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="title"
                  :options="entries"
                  @change="changeSizePage"
                />
              </b-form-group>
            </b-col>
            <b-col sm="3" class="mt-75" style="font-size: 12px">
              <span> {{ totalElements }} Registros en total</span>
            </b-col>
            <!-- Pagination -->
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalElements"
                :per-page="showEntrie"
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
                @change="cambioPagina"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>
  </div>
</template>

<script> 
import Vue from 'vue';
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import cajaFilters from './cajaFilters.vue'
import SaleService from '@/services/SaleService'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
export default {
  directives: {
    'b-tooltip': VBTooltip,
    Ripple
  },
  data() {
    return{
        showLoading: false,
        records: [],
        fields: [
          { key: 'documentCode', label: 'Número de Documento', sortable: true },
          { key: 'quote.updated_at', label: 'Fecha Creación', sortable: false},
          { key: 'quote.clientDni', label: 'Documento Cliente', sortable: false},
          { key: 'establishmentOrigin.name', label: 'Establecimiento', sortable: false},
          { key: 'quote.clientName', label: 'Nombre Cliente', sortable: false},
          { key: 'actions', label: 'Acciones', sortable: false},
        ],
        arrayFilters: [],
        currentPage: 1,
        entries: [10, 20, 50, 100],
        showEntrie: 10,
        totalElements: 0,
        id: 0,
        sort: 'id',
        order: 'desc',
    }
  },
  components:{
    cajaFilters
  },
  mounted(){
    this.getData()
  },
  methods: {
    cambioPagina(e) {
      this.currentPage = e
    },
    changeSizePage() {
      this.getData()
    },
    sortChanged(data) {
      this.sort = data.sortBy
      if (data.sortDesc) {
        this.order = 'desc'
      } else this.order = 'asc'
    },

    async getData(){
      this.records = []
      this.totalElements = 0
      this.showLoading = true
      this.arrayFilters = [];
      
      const url = `?limit=1000&page=1&order=desc&sort=id`;
      console.log("URL", url)
      const resp = await SaleService.getSales(url, this.$store);
      
      if (resp?.data?.rows) {
        this.records = resp.data.rows.filter(item =>
          item.state === 'Caja'
        )
        this.totalElements = this.records.length
      }
          
      this.showLoading = false;
    },

    formatDateTime(date) {
      if (!date) return "Sin fecha"; 
      const d = new Date(date);

      d.setHours(d.getHours() - 4);

      const year = d.getUTCFullYear();
      const month = String(d.getUTCMonth() + 1).padStart(2, "0"); 
      const day = String(d.getUTCDate()).padStart(2, "0"); 
      const hours = String(d.getUTCHours()).padStart(2, "0");
      const minutes = String(d.getUTCMinutes()).padStart(2, "0"); 

      return `${year}-${month}-${day} - ${hours}:${minutes}`;
    },

    detail(item){
      console.log(item)
      this.$router.push('/caja/detail/' + item.id)
    },

    async deleteAction(data) {
      this.$swal({
        title: '¿Desea eliminar esta proforma?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si, eliminala',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1'
        },
        buttonsStyling: false
      }).then((result) => {
        if (result.value) {
          this.currentPage = 1
          this.$swal({
            icon: 'success',
            title: 'Eliminado!',
            text: 'La proforma ha sido eliminada.',
            customClass: {
              confirmButton: 'btn btn-success'
            }
          })
          this.deleteData(data.item.id)
        }
      })
    },
    
    async deleteData(id) {
      const resp = await SaleService.deleteSale(id, this.$store)
      if (resp) {
        this.getData()
      } else {
        this.$swal({
          icon: 'error',
          title: 'Error',
          text: 'Ocurrió un error al eliminar la venta.',
          customClass: {
            confirmButton: 'btn btn-success'
          }
        })
      }
    },

  },
}


</script>